import * as actionTypes from '../constants/index'

const personnelList = (list = [], action) => {

    switch (action.type) {
        case actionTypes.set_personnel_list:
            let data = action.data.concat();
            let chooseData = action.chooseData.concat();
            for (let _item of chooseData) {
                for (let item of data) {
                    if (item.userId == _item.userId) {
                        item.check = true;
                        break
                    }
                }
            }
            for (let item of data) {
                if (!item.check) {
                    item.check = false
                }
            }
            return data;
        case actionTypes.update_personnel_list:
            //原来的值  list
            list = list.concat();
            let data_ = action.data;
            list.map((item) => {
                if (action.chooseType == "radio") {
                    if (item.userId == data_.userId) {
                        item.check = true
                    } else {
                        item.check = false
                    }
                } else {
                    if (item.userId == data_.userId) {
                        item.check = !(item.check)
                    }
                }
            });
            //check
            return list;
        case actionTypes.add_personnel_list:
            let _list = action.data;
            let _chooseData = action.chooseData.concat();

            for (let _item of _chooseData) {
                for (let item of _list) {
                    if (item.userId == _item.userId) {
                        item.check = true;
                        break
                    }
                    else {
                        item.check = false

                    }
                }
            }
            list = list.concat(_list);

            return list;
        default:
            return list
    }
};


const choosePerson = (data = [], action) => {
    switch (action.type) {
        //初始化选中人员数据
        case actionTypes.set_person_data:
            data = action.data.concat();
            for (let item of data) {
                item.check = true
            }
            return data;

        case actionTypes.set_choose_person:
            let checkData = action.data;
            if (action.chooseType == "radio") {
                data = [];
                data.push(checkData)
            } else {
                data = data.concat();
                //check 为true添加人员，为false删除人员
                if (checkData.check) {
                    data.push(checkData)
                } else {
                    let index = data.findIndex((item) => {
                        return item.userId == checkData.userId
                    });
                    data.splice(index, 1)
                }
            }
            return data;
        case actionTypes.delete_choose_person:
            data = data.concat();
            let deleteData = action.data;

            data.splice(data.indexOf(deleteData), 1);
            return data;
        default:
            return data
    }
};


// Reducer
const deptPersonState = {
    unfoldDPId: ["1", "1693"],
    selectDPId: [],
    selectDPList: [],
    searchList: [],
};


const deptPerson = (state = deptPersonState, action) => {
    switch (action.type) {
        case actionTypes.set_unfold_dept_person:
            const unfoldDPId = state.unfoldDPId;
            const inx1 = unfoldDPId.indexOf(action.id);
            if (inx1 >= 0) {
                unfoldDPId.splice(inx1, 1)
            } else {
                unfoldDPId.push(action.id)
            }
            return {
                ...state,
                unfoldDPId,
            };
        case actionTypes.set_select_dept_person:
            const selectDPId = state.selectDPId;
            const selectDPList = state.selectDPList;
            const type = action.data.type;
            let inx2;
            if (type == "dept") {
                inx2 = selectDPId.indexOf(`dept_${action.data.orgId}`);
            } else if (type == "person") {
                inx2 = selectDPId.indexOf(`person_${action.data.userId}`);
            } else {
                inx2 = -1
            }
            if (inx2 >= 0) {
                selectDPId.splice(inx2, 1);
                selectDPList.splice(inx2, 1);
            } else {
                if (type == "dept") {
                    selectDPId.push(`dept_${action.data.orgId}`);
                } else {
                    selectDPId.push(`person_${action.data.userId}`);
                }
                selectDPList.push(action.data);
            }
            return {
                ...state,
                selectDPId,
                selectDPList,
            };
        case actionTypes.set_default_dept_person:
            const def_selectDPId = [];
            const def_selectDPList = [];
            const data = action.data;
            for (const o of data) {
                if (o.type == "dept") {
                    def_selectDPId.push(`dept_${o.orgId}`);
                } else {
                    def_selectDPId.push(`person_${o.userId}`);
                }
                def_selectDPList.push(o);
            }
            return {
                ...state,
                selectDPId: def_selectDPId,
                selectDPList: def_selectDPList,
            };
        case actionTypes.set_search_dept_person:
            const value = action.value;
            const dataSource = action.data.concat();
            const searchList = [];
            const randerSearch = (value, dataSource) => {
                if (dataSource instanceof Array) {
                    for (let item of dataSource) {
                        let orgName = item.orgName || item.zhName;
                        if (value && orgName.includes(value)) {
                            // item.childList = null;
                            searchList.push(item)
                        }
                        if (item.childList && item.childList.length) {
                            randerSearch(value, item.childList)
                        }
                    }
                }
            };
            randerSearch(value, dataSource);
            return {
                ...state,
                searchList,
            };

        default:
            return state;
    }
};


export {personnelList, choosePerson, deptPerson}